export default "__VITE_ASSET__db61a8d1__"